import { render, staticRenderFns } from "./UkrposhtaCreationSection.vue?vue&type=template&id=dfe7851e"
import script from "./UkrposhtaCreationSection.vue?vue&type=script&lang=js"
export * from "./UkrposhtaCreationSection.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaCreationSection.vue?vue&type=style&index=0&id=dfe7851e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports